module.exports = __webpack_public_path__ + "bc8199e6.png";